import React, { Component } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

const handleStyle = {
    borderColor: "#F5922F",
    top: "17px",
    height: "28px",
    width: "28px",
};

const trackStyle = {
    "term_loan": {
        background: "linear-gradient(144.56deg, #F17920 35.52%, #F5A62F 76.1%)",
    },
    "receivables_financing": {
        background: "linear-gradient(144.56deg, #775A9C 35.52%, #F5A62F 76.1%)",
    },
    "credit_line": {
        background: "linear-gradient(144.56deg, #3568E9 35.52%, #F5A62F 76.1%)",
    },
};

const railStyle = {
    backgroundColor: "#DBDDE1",
};

export default class UBXSlider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: false,
        };
    }

    handleBlur = (value) => {
        const { onBlur = false } = this.props;

        if (onBlur) {
            onBlur(value);
        }
    };

    handleChange = (value) => {
        const { onChange = false } = this.props;

        this.setState({ value });

        if (onChange) {
            onChange(value);
        }
    };

    render() {
        const { min = 0, max = 100, step = 1, value: propValue = false, loanType = "term_loan" } = this.props;
        const { value: stateValue = min } = this.state;

        return (
            <div>
                <Slider
                    className="ubx-slider"
                    min={min}
                    max={max}
                    step={step}
                    value={propValue ? propValue : stateValue}
                    handleStyle={handleStyle}
                    trackStyle={trackStyle[loanType]}
                    railStyle={railStyle}
                    onChange={this.handleChange}
                    onAfterChange={this.handleBlur}
                />
            </div>
        );
    }
}
